<form class="recaptcha-root" [formGroup]="formGroup">
  <re-captcha #captchaRef="reCaptcha"
              [formControlName]="abstractFormControlName"></re-captcha>
</form>
